import {addRoleSuffix, getSimplexUnitName} from 'helpers/simplex-helper';
import RuleBuilder from 'services/simplex/rule-builder';
import {isPlayerOnDoublePosition} from 'helpers/player-helper';

export class ConstraintsBuilder {
    constructor(dependencies) {
        this.dependencies = {...dependencies};
    }

    isPlayerOnSinglePosition(playerId) {
        const {checkIfPlayerOnDoublePosition, players} = this.dependencies;

        if (!checkIfPlayerOnDoublePosition) {
            return true;
        }

        return !(playerId in players && isPlayerOnDoublePosition(players[playerId]));
    }

    createRow(playerId, constant, modes) {
        const row = {};
        if (this.isPlayerOnSinglePosition(playerId)) {
            if (isEmpty(modes)) {
                row[getSimplexUnitName(playerId)] = constant;
            } else {
                modes.map((mode) => {
                    const simplexModeUnitName = addRoleSuffix({
                        prefix: getSimplexUnitName(playerId),
                        role: mode,
                    });
                    row[simplexModeUnitName] = constant;
                });
            }
        } else {
            const {players} = this.dependencies;

            players[playerId].position.map((pos) => {
                row[getSimplexUnitName([playerId, pos])] = constant;
            });
        }

        return row;
    }

    createConstraintForExpMaxCombinations(params) {
        const {combinationsState} = params;
        let rules = [];
        Object.keys(combinationsState).map((keyPlayerId) => {
            const keyPlayerRules = this.createConstraintForKeyPlayerExpMaxCombinations({
                keyPlayerId,
                combinations: combinationsState[keyPlayerId],
            });

            rules = [...rules, ...keyPlayerRules];
        });

        return rules;
    }

    createConstraintForKeyPlayerExpMaxCombinations(params) {
        const {keyPlayerId, combinations} = params;
        const rules = [];
        Object.values(combinations).map((combo) => {
            const {maxQuantity, stackedPlayerIds} = combo;

            if (0 < maxQuantity || isEmpty(stackedPlayerIds)) {
                return;
            }

            const builder = RuleBuilder.fromAtMost(stackedPlayerIds.length);
            builder.addVars(this.createRow(keyPlayerId, 1));
            stackedPlayerIds.map((playerId) => builder.addVars(this.createRow(playerId, 1)));

            rules.push(builder.createRule());
        });

        return rules;
    }
}
